import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Button
 * 
 * Unified button component with variants and loading state.
 * 
 * Variants:
 * - primary: Gradient (Blue/Purple)
 * - success: Gradient (Green)
 * - outline: Border only
 * - ghost: Text only
 * - game: Neon gaming style
 */
const Button = ({
    children,
    onClick,
    type = 'button',
    variant = 'primary',
    className = '',
    loading = false,
    disabled = false,
    icon: Icon
}) => {
    const baseStyles = "relative font-bold py-3.5 px-6 rounded-xl transition-all duration-300 transform flex items-center justify-center gap-2 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none disabled:active:scale-100";

    const variants = {
        primary: "bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white shadow-lg",
        success: "bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white shadow-lg",
        secondary: "bg-white text-gray-700 hover:bg-gray-50 border border-gray-200 shadow-sm hover:shadow",
        outline: "bg-transparent border-2 border-current hover:bg-gray-50/10",
        ghost: "bg-transparent hover:bg-gray-100 text-gray-600 hover:text-gray-900",
        game: "neon-border-pink bg-gradient-to-r from-pink-600 to-purple-600 text-white shadow-xl uppercase tracking-wider"
    };

    const variantStyles = variants[variant] || variants.primary;

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled || loading}
            className={`${baseStyles} ${variantStyles} ${className}`}
        >
            {loading ? (
                <>
                    <Loader2 className="w-5 h-5 animate-spin" />
                    <span>Loading...</span>
                </>
            ) : (
                <>
                    {Icon && <Icon className="w-5 h-5" />}
                    {children}
                </>
            )}
        </button>
    );
};

export default Button;
